import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import TopBar from '../../../global/TopBar';
import { PlusIcon, PencilIcon, TrashIcon } from '@heroicons/react/20/solid';

// Import the sampleRestaurantData from the Restaurant component
//import { sampleRestaurantData } from '../index';

const DishList = () => {
  // const { restaurantId } = useParams();
  // const [dishes, setDishes] = useState([]);

  // useEffect(() => {
  //   // Fetch dishes from API
  //   // For now, we'll use sample data
  //   if (sampleRestaurantData[restaurantId]) {
  //     setDishes(sampleRestaurantData[restaurantId].categories.flatMap(cat => cat.items));
  //   }
  // }, [restaurantId]);

  const handleDelete = (dishId) => {
    // Implement delete functionality
  };

  return (
    <>
      <TopBar />
      {/* <div className="container mx-auto px-4 py-8 text-white">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold">Manage Dishes</h1>
          <Link to={`/food/restaurant/${restaurantId}/manage/dishes/add`} className="bg-pri-yellow text-pri-dark font-semibold py-2 px-4 rounded-md flex items-center">
            <PlusIcon className="h-5 w-5 mr-2" />
            Add New Dish
          </Link>
        </div>
        <div className="bg-sec-dark rounded-lg shadow-md overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-800">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-pri-gray uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-pri-gray uppercase tracking-wider">Price</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-pri-gray uppercase tracking-wider">Category</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-pri-gray uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {dishes.map((dish) => (
                <tr key={dish.id}>
                  <td className="px-6 py-4 whitespace-nowrap">{dish.name}</td>
                  <td className="px-6 py-4 whitespace-nowrap">£{dish.price.toFixed(2)}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{dish.category}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <Link to={`/food/restaurant/${restaurantId}/manage/dishes/edit/${dish.id}`} className="text-pri-blue hover:text-pri-yellow mr-4">
                      <PencilIcon className="h-5 w-5 inline" />
                    </Link>
                    <button onClick={() => handleDelete(dish.id)} className="text-pri-red hover:text-pri-yellow">
                      <TrashIcon className="h-5 w-5 inline" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}
    </>
  );
};

export default DishList;